import { useRef } from 'react'
import { MdArrowBack } from 'react-icons/md'

import type { RowClickedEvent } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { IAppSummary } from '~/types/application'
import type { ITemplate } from '~/types/template'

import columns from './columns'

import Label from '~/components/Label'
import { ModalBody } from '~/components/Modal/Layout'
import TableWrapper from '~/components/Tables/TableWrapper'
import { getTemplateFromKey } from '~/utils/template'

import './styles.scss'

interface Props {
  isLoading: boolean
  onBackClick: VoidFunction
  onTemplateClick: (templateKey: string) => void
  selectedApp?: IAppSummary
  templates: ITemplate[]
}

export interface ITemplateData {
  templateKey: string
  title: string
  versionCount: number
}

const TemplateSelector = ({ onBackClick, onTemplateClick, templates }: Props): ReactElement => {
  /** Local state */

  const tableRef = useRef<HTMLDivElement>(null)

  const templateOptions = templates
    ?.filter(({ template_key }) => !!getTemplateFromKey(template_key))
    .reduce((templateData, { template_key, title }) => {
      const foundElementIndex = templateData.findIndex(({ templateKey }) => templateKey === template_key)

      if (foundElementIndex > -1) {
        templateData[foundElementIndex].versionCount++
      } else {
        templateData.push({ templateKey: template_key, title, versionCount: 1 })
      }

      return templateData
    }, [] as ITemplateData[])

  /** Handlers */

  const handleRowClicked = (evt: RowClickedEvent<ITemplateData>) => {
    evt.data && onTemplateClick(evt.data.templateKey)
  }

  return (
    <ModalBody className="template-selector-modal__body">
      <div className="template-selector-modal-container">
        <div className="back-navigation-container" onClick={onBackClick}>
          <MdArrowBack size={18} />
          <Label label="Back to applications" />
        </div>
        <div className="template-selector-modal-content">
          <TableWrapper
            className="with-min-height"
            columnDefs={columns}
            entriesName="templates"
            onRowClicked={handleRowClicked}
            rowData={templateOptions}
            tableRef={tableRef}
            withSearchBar
            withSearchBarAutoFocus
          />
        </div>
      </div>
    </ModalBody>
  )
}

export default TemplateSelector
